<template>
    <div class="container">
        <Header/>

        <div class="challenge_content">
            <div class="section_name">{{sectionName}}</div>
            <div class="content_nav">
                <div class="topic" v-if="step == 1">
                    <div class="title" style="background-color: #eeeeee;">
                        <span style="display: flex;justify-content: space-between;">
                            <span class="tipic_desc">{{TopicData[currIndex] ? TopicData[currIndex].examTypeDesc : ''}}</span>
							<span v-if="currIndex < (submitData.length - 1) "
								  style="cursor: pointer;
								  	margin: 6px 48px 6px 15px;
    								font-size: 14px;line-height: 28px;height: 28px;
    								background-color: #0079fe;
    								color: #fff;border-radius: 4px;
    								width:74px;text-align: center;"
								  class="next_btn" @click="nextTopic">{{"下一题"}}</span>
                        </span>

                    </div>
                    <div class="topic_content">
                        <div class="content_html" :id="'content_'+currIndex" v-html="TopicData[currIndex] ? TopicData[currIndex].content : ''"></div>
                    </div>
                    <div class="next" v-if="currIndex < (submitData.length - 1) ">
                        <el-button class="next_btn" @click="nextTopic">{{"下一题"}}</el-button>
                    </div>
                </div>
                <div class="topic_step2" id="topic_step2" v-if="step == 2">
                    <div class="aaa" :id="'topic'+ index" v-for="(item, index) in topicDetail" :key="index">
                        <div class="topic_content">
                            <div class="topic_title">
                                <div class="content_html" v-html="item.content"></div>
                            </div>
                            <div>
                                <div class="answer_div" v-if="!item.isRight">
                                    <span>正确答案：</span>
                                    <span>
                                        <span class="answer">{{ item.rightAnswer }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="content_bottom">
                            <fieldset class="fieldset">
                                <div class="knowledge">
                                    <el-dialog
                                            :visible.sync="problemsPopover"
                                            top="35vh"
                                            width="500px"
                                            custom-class="EscModal"
                                            @closed="problemDialogClosed"
                                            :key="item.id"
											title="报告问题"
                                    >
                                        <div :id="'pop'+index" style="height:155px;">
											<el-checkbox-group v-model="textarea" style="margin-left:80px;width: 65%;">
												<el-checkbox value="答案一致，批改错误" label="答案一致，批改错误" style="float:left;">
													<span style="font-size: 20px;line-height: 25px;">答案一致，批改错误</span>
												</el-checkbox>
												<el-checkbox value="参考答案不正确" label="参考答案不正确" style="float:left;">
													<span style="font-size: 20px;line-height: 25px;">参考答案不正确</span>
												</el-checkbox>
												<el-input v-model="inputTextarea" placeholder="有其他问题？请在此处填写"
														  style="font-size:20px;line-height:30px;float:left;margin-bottom:5px;"></el-input>
											</el-checkbox-group>
                                            <div style="text-align: right; float:right; margin: 0">
                                                <el-button size="mini" type="text" @click="problemsPopover = false">取消
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="reportProblem(item.id)">
                                                    确定
                                                </el-button>
                                            </div>
                                        </div>
                                    </el-dialog>
                                    <el-button class="intelligent_tutoring"
                                               style="pointer-events: auto;" type="text"
                                               @click="onImproveProblems(item)"><i class="iconfont">&#xe601;</i>我要纠错
                                    </el-button>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div v-if="step === 1" class="Subject_right">
                    <div class="Popup">
                        <span @click="centerDialogVisible = true">结束练习</span>
                        <el-dialog
                                v-if="step === 1"
                                :visible.sync="centerDialogVisible"
                                :modal="false"
                                top="35vh"
                                width="432px"
                                custom-class="EscModal"
                        >
                            <div class="Tips">
                                <div class="top">
                                    <p class="p1"><span class="warning">!</span> 退出训练则成绩无效</p>
                                    <p class="p2">答完所有题目，确认交卷后才会获得评测结果</p>
                                </div>
                                <div class="btn_div">
                                    <div class="btn1">
                                        <el-button type="primary btn" @click="centerDialogVisible = false">继续训练
                                        </el-button>
                                        <el-button type="primary btn" @click="signOut">退出训练</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-dialog>
                        <el-dialog
                                v-if="step === 2"
                                :visible.sync="centerDialogVisible"
                                :modal="false"
                                top="35vh"
                                width="432px"
                                custom-class="EscModal"
                        >
                            <div class="Tips">
                                <div class="btn_div">
                                    <div class="btn1">
                                        <el-button type="primary btn" @click="onceAgain">继续训练
                                        </el-button>
                                        <el-button type="primary btn" @click="signOut">退出训练</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-dialog>
                    </div>
                    <div class="times">
                        <div class="title_name">答题时间</div>
                        <div class="title_time">
                            <div ref="startTimer">{{basicsData.totalLongOfTime}}</div>
                        </div>
                    </div>
                    <!-- 点击显示隐藏部分 -->
                    <!-- 点击提交前的样式 -->
                    <div class="hides" v-if="step == 1">
                        <div class="hide">
                            <div class="title">还剩{{nofinishNum}}题未完成</div>
                            <div class="challenge_progress">
                                <div class="progress_div" style="display: flex;flex-wrap: wrap;" v-if="step === 1">
									<span class="progress_item1" v-for="(item, index) in submitData" :key="'ss'+index"
										  style="margin: 5px;position: unset;cursor: pointer;"
										 :class="currIndex === index ? 'current_progress_item' : (isEnd || (submitData[index].isfinish)) ? 'finished_progress_item' : 'unfinished_progress_item'"
										 @click="changeTopicNum(index)">
										<span class="num">{{index + 1}}</span>
									</span>
                                </div>
                            </div>

                            <div id="dian" v-if="step === 1 && nofinishNum === 0">
                                <el-button
                                        class="finish_btn"
                                        type="primary"
                                        size="medium"
                                        @click="endAnswer"
                                >
                                    {{con}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="top">
                <div class="hill">
                    <div>
                        <img class="img3" src="../../src/assets/images/u36.png"/>
                    </div>
                </div>
                <div class="train">
                    <div>
                        <img class="img3" src="../../src/assets/images/u36.png"/>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="railway">
                    <img class="img4" src="../../src/assets/images/u1.png"/>
                </div>
            </div>
        </div>
        <div v-if="step === 2" class="Subject_right_float">
            <div class="Popup">
                <span @click="centerDialogVisible = true">结束练习</span>
                <el-dialog
                        v-if="step === 1"
                        :visible.sync="centerDialogVisible"
                        :modal="false"
                        top="35vh"
                        width="432px"
                        custom-class="EscModal"
                >
                    <div class="Tips">
                        <div class="top">
                            <p class="p1"><span class="warning">!</span> 退出训练则成绩无效</p>
                            <p class="p2">答完所有题目，确认交卷后才会获得评测结果</p>
                        </div>
                        <div class="btn_div">
                            <div class="btn1">
                                <el-button type="primary btn" @click="centerDialogVisible = false">继续训练
                                </el-button>
                                <el-button type="primary btn" @click="signOut">退出训练</el-button>
                            </div>
                        </div>
                    </div>
                </el-dialog>
                <el-dialog
                        v-if="step === 2"
                        :visible.sync="centerDialogVisible"
                        :modal="false"
                        top="35vh"
                        width="432px"
                        custom-class="EscModal"
                >
                    <div class="Tips">
                        <div class="btn_div">
                            <div class="btn1">
                                <el-button type="primary btn" @click="onceAgain">继续训练
                                </el-button>
                                <el-button type="primary btn" @click="signOut">退出训练</el-button>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <div class="times">
                <div class="title_name">答题时间</div>
                <div class="title_time">
                    <div ref="startTimer">{{basicsData.totalLongOfTime}}</div>
                </div>
            </div>
            <!-- 点击提交后的样式 -->
            <div class="hides" v-if="step === 2">
                <div class="hide">
                    <div class="line"></div>
                    <div class="questions">
                        <div class="correct">
                            <p class="number">{{basicsData.rightNum}}</p>
                            <p class="name">正确</p>
                        </div>
                        <div class="error">
                            <p class="number">{{basicsData.errorNum}}</p>
                            <p class="name">错误</p>
                        </div>
                    </div>
                    <div class="challenge_progress" style="height: 195px;">
                        <div class="progress_div" style="display: flex;flex-wrap: wrap;" v-if="step === 2">
							<span class="progress_item1" v-for="(item, index) in submitData" :key="'s'+index"
								  style="margin: 5px;position: unset;cursor: pointer;"
								  :class="topicDetail[index] ? topicDetail[index].isRight ? 'right_progress_item' : 'error_progress_item' : ''"
								  @click="changeTopicNum(index)">
										<span class="num">{{index + 1}}</span>
									</span>
                        </div>
                    </div>
                    <div class="tips">{{ basicsData.remark ? basicsData.remark :"继续努力，加油！"}}</div>
                    <div class="again">
                        <div @click="onceAgain" class="btn">再次挑战</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step === 2 && basicsData.isFinishTask && showMoneyAnimate" class="mask"/>
        <div v-if="step === 2 && basicsData.isFinishTask && showMoneyAnimate" class="money_animate"/>
    </div>
</template>

<script>
    import Header from "../components/common/Header";
    import api from "../axios/interface";
    export default {
        name: "Enchallenge",
        components: {
            Header: Header
        },
        props: {
            time: {
                type: Number
            }
        },
        data() {
            return {
                con: "交卷",
                flag: false,
                centerDialogVisible: false,
                problemsPopover: false,
                textarea: [],
				inputTextarea: "",
                progress: 0,
                itemsValue: ["A", "B", "C", "D"],
                answer: "",
                answers: new Map(),
                submitted: false,
                score: 0,
                multiAnswer: [],
                size: 10,
                TopicData: [],
                step: 1,
                currIndex: 0,
                radioValue: "", // 当前单选题选项
                checkList: [], // 当前选择数组
                judgeOption: "",
                timer: null,
                topicTimer: null,
                oneTopicTimer: 0,
                content: "",
                hour: 0,
                minutes: 0,
                seconds: 0,
                currtimer: 0, // 当前计时
                judgeData: [{isAnswer: 0}, {isAnswer: 1}],
                sectionId: this.$route.query.sectionId,
                subjectId: this.$route.query.subjectId,
                taskId: this.$route.query.taskId,
                type: this.$route.query.type,
                sectionName: this.$route.query.name,
                isDisabled: true, // 是否可以点击下一题
                errorGroupId: "", // 题组id
                params: {},
                paramsItem: {},
                groupIdInfo: {},
                groupIdTotal: 0,
                topicDetail: [],
                dialogVisible: false,
				examAnalysisDialogVisible: false,
                videoUrl: "",
                submitData: [],
                basicsData: {},
                isEnd: false,
                currentVideoArr: [],
                currentVideoIndex: 0,
                currentKnowledge: "",
                currentVideoDialogType: "",
                currentSelectedItem: {},
                showMoneyAnimate: false, // 是否展示金币动画
                showMoneyAnimateTimer: null,
				examAnalysis: '',
				enType: this.$route.query.enType,//1单词默写，2短语默写，3句子默写
            };
        },
        created() {

        },
        computed: {
            nofinishNum() {
                let num = 0;
                this.submitData.forEach((item) => {
                    if (Number(item.isfinish) === 0) {
                        num = num + 1;
                    }
                });
                console.log(this.submitData)
                return num;
            }
        },
        updated() {
            let that = this;
			this.$nextTick().then(() => {
				$(".tiankong").on("blur", function (e) {
					this.setAttribute("value",this.value);
					let examCurrIndex = e.target.id.split("_")[1]-1;
					that.TopicData[examCurrIndex].content = $("#content_"+examCurrIndex).html();
					if (this.value) {
						that.clickOption(e);
					}
				});
				$(".tiankong").on("input", function (e) {
					if (this.value) {
						if (this.value.length > 4) {

							this.size = this.size < 648 ? this.size + 1 : this.size;
							if(this.style.width==""){
								this.style.width="60px";
							}
							this.style.width = parseFloat(this.style.width.split('px')[0]) + Math.round(800/this.value.length)/100 + "px";
						}
						that.clickOption(e);
					}
				});
				$(".tk_textarea").on("blur", function (e) {
					this.setAttribute("value",this.value);
					this.innerHTML=this.value;
					let examCurrIndex = e.target.id.split("_")[1]-1;
					that.TopicData[examCurrIndex].content = $("#content_"+examCurrIndex).html();
					console.log(that.TopicData[examCurrIndex].content)
					if (this.value) {
						that.clickOption(e);
					}
				});
				$(".tk_textarea").on("input", function (e) {
					if (this.value) {
						that.clickOption(e);
					}
				});
			});
        },
        mounted() {
            this.getTopic();
        },
        methods: {
            onImproveProblems(item) {
                this.problemsPopover = true;
                this.currentSelectedItem = item;
            },
            problemDialogClosed() {
                this.textarea = [];
                this.inputTextarea = "";
            },
            onceAgain() {
                if (this.centerDialogVisible) {
                    this.centerDialogVisible = false;
                }
                this.$router.go(0);
            },
            stop() {
                clearInterval(this.timer);
            },
            start() {
                this.timer = setInterval(this.startTimer, 1000);
            },
            //下一题
            next: function () {
                if (this.progress < this.size) {
                    this.answers.set(this.progress, this.answer);
                    this.progress++;
                    this.answer = "";
                // } else if (this.progress < 10) {
                //     this.answers.set(this.progress, this.multiAnser);
                //     this.progress++;
                //     this.multiAnser = [];
                }
            },
            //返回
            back: function () {
            },
            enter: function () {
                this.nextTopic();
                this.flag = !this.flag;
                if (this.flag == true) {
                    this.con = "继续挑战";
                } else if (this.flag == false) {
                    this.con = "交卷";
                }
            },

            init() {
                if (this.step == 2) {
                    let timerdiv = $("#timerdiv");
                    let topic2 = $("#topic_step2");
                    let topic2Top = topic2.offset().top;
                    let timerTop = timerdiv.offset().top;
                    $.event.add(window, "scroll", () => {
                        let p = $(window).scrollTop();
                        if (p > timerTop && p > topic2Top) {
                            // 到顶部
                            timerdiv.css("position", "fixed");
                            timerdiv.css("top", 0);
                            timerdiv.css("height", "610px");
                            timerdiv.css("margin-left", "672px");
                        } else {
                            timerdiv.css("position", "rilative");
                            timerdiv.css("margin-left", "48px");
                        }
                    });
                }
            },
            // 获取挑战做题数据统计接口
            getTopic() {
                let that = this;
                let url, params;
                //根据type类型，获取章节训练或任务试题
                if (this.type == 1) {
                    url = api.CHALLENGEBYCAPTER;
                    params = {sectionId: this.sectionId, type: this.enType};
                } else {
                    url = api.CHALLENGEBYTASK;
                    params = {taskId: this.taskId};
                }
                this.$axios.get(url, params,
                    {hideMessage: true}
                )
                    .then(res => {
                        clearInterval(this.timer);
                        this.timer = setInterval(this.startTimer, 10);
                        res.result.data.map(item => {
                        	if(item.examTypeDesc == '句子默写'){
								item.content = item.content.replace(
									/\[Space\]/g,
									"</br><textarea rows='3' cols='58' id=\"input_" + item.index + "_" + item.id + "\" class=\"tk_textarea\"></textarea>"
								);
							}else{
								item.content = item.content.replace(
									/\[Space\]/g,
									"<input type=\"text\" id=\"input_" + item.index + "_" + item.id + "\" class=\"tiankong\"></input>"
								);
							}
                        });
                        this.TopicData = res.result.data;
                        this.groupIdTotal = res.result.data.length;
                        res.result.data.forEach((item, index) => {
                            this.submitData.push({id: item.id, isfinish: 0});
                        });
                    })
                    .catch(res => {
                    });
            },

            Refresh() {
                this.$router.go(0);
            },

            goHome() {
                this.$router.push({
                    name: "Home",
                    query: this.subjectId
                });
            },

            handleClose() {
                this.dialogVisible = false;
				this.examAnalysisDialogVisible = false;
                this.videoUrl = "";
            },

            changeTopicNum(num) {
                if (this.step == 1) {
                    this.currIndex = num;
                } else if (this.step == 2) {
                    $("html,body").animate({
                        scrollTop: $(`#topic${num}`).offset().top - 50
                    }, 400);
                }

            },

            // 选择题选项
            clickOption(e) {
				this.params = {
					answers: e.target.value,
					examType: 3,
					currIndex: e.target.id.split("_")[1],
					id: e.target.id.split("_")[2]
				};
				// this.isDisabled = false;
				this.submit(this.params);
            },

            // 下一题
            nextTopic() {
            	// console.log("nextTopic this.params.currIndex : "+this.params.currIndex)
            	// console.log("nextTopic this.currIndex : "+this.currIndex)
                if (this.params.currIndex === this.currIndex) {
                    if (this.params.answers == 'undefined') {
                        this.currIndex = this.currIndex + 1;
                        return;
                    }
                } else {
                    this.currIndex = this.currIndex + 1;
                    return;
                }

                this.submit(this.params);
                // 如果当前题不是最后一题
                if (this.currIndex + 3 === this.TopicData.length) {
                    this.endAnswer();
                    // 跳转页面
                } else if (this.currIndex +3 < this.TopicData.length) {
                    this.currIndex = this.currIndex + 1;
                    this.isDisabled = true;
                }
            },

            // 提交当前题目
            submit(params) {
                let nowTopictime;
                nowTopictime = this.oneTopicTimer;
                this.oneTopicTimer = 0;
                this.submitData = this.submitData.map((item, index) => {
                    if (item.id === this.TopicData[params.currIndex-1].id) {
                        item.answers = String(params.answers);
                        item.isfinish = 1;
                        if (item.time) {
                            item.time = item.time + nowTopictime;
                        } else {
                            item.time = nowTopictime;
                        }
                    }
                    return item;
                });
            },

            // 结束订正
            endAnswer() {
                this.isEnd = true;
                let url, params;
                setTimeout(() => {
                    this.step = 2;
                }, 1200);
                clearInterval(this.timer);
                let arr = this.submitData;
                arr.forEach(e => {
                    delete e.isfinish;
                });
                let answerData = JSON.stringify(arr);
                // 交卷
                if (this.type == 1) {
                    url = api.ENCHALLENGEBYCAPTERSUBMIT;
                    params = {
                        sectionId: this.sectionId,
                        answer: answerData
                    };
                } else {
                    url = api.ENCHALLENGEBYTASKSUBMIT;
                    params = {
                        taskId: this.taskId,
                        answer: answerData
                    };
                }
                this.$axios.post(url, params,
                    {bodyType: "form", hideMessage: true}
                )
                    .then(res => {
                        this.topicDetail = res.result.data ? res.result.data : [];
                        this.basicsData = res.result.basicsData;
                        // 完成了当前任务，则展示动画
                        if (this.basicsData && this.basicsData.isFinishTask) {
                            this.showMoneyAnimate = true;
                            this.showMoneyAnimateTimer = setInterval(() => {
                                this.showMoneyAnimate = false;
                            }, 3000);

                        }
                    }).catch(error => {
                    }
                );
            },

            GoBack() {
                this.$router.go(-1);
            },

            startTimer() {
                this.currtimer += 10;
                this.oneTopicTimer += 10;
                this.seconds += 10;
                if (this.seconds / 1000 >= 60) {
                    this.seconds = 0;
                    this.minutes = this.minutes + 1;
                }

                if (this.minutes >= 60) {
                    this.minutes = 0;
                    this.hour = this.hour + 1;
                }
                this.$refs.startTimer.innerHTML =
                    (this.hour < 10 ? "0" + this.hour : this.hour) +
                    ":" +
                    (this.minutes < 10 ? "0" + this.minutes : this.minutes) +
                    ":" +
                    (Math.round(this.seconds / 1000) < 10 ? "0" + Math.round(this.seconds / 1000) : Math.round(this.seconds / 1000));
            },
            signOut() {
                if (this.type == 1) {
                    this.$router.push({
                        name: "subjecthome",
                        query: {subjectId: this.subjectId}
                    });
                } else {
                    this.$router.push({
                        name: "Home",
                        query: {}
                    });
                }
            },
            reportProblem(id) {
                let that = this;
                let feedbackContent = "";
                if(that.textarea.length>0 || that.inputTextarea != ""){
                	that.textarea.forEach((r)=>{
						feedbackContent += ";"+r;
					})
					feedbackContent = that.inputTextarea +feedbackContent;
					this.$axios.get(api.EnErrorTopicFeedback, {id: this.currentSelectedItem.id, content: feedbackContent}, {hideMessage: true})
						.then(res => {
							that.problemsPopover = false;
							that.$message.success("反馈成功，非常感谢，我们会在第一时间进行处理！");
						});
				}else{
					that.$message.success("麻烦您完善一下反馈信息！");
				}
            },
        },
        destroyed() {
            clearInterval(this.timer);
            if (this.showMoneyAnimateTimer) {
                clearInterval(this.showMoneyAnimateTimer);
            }
        }
    };
</script>
<style>
	.content_html {
		padding: 15px 0;
	}
	.content_html span{
		font-size: 15px;
	}
	.content_html input{
		font-size: 20px;
	}
    .content_html .tiankong {
        padding: 0 10px;
		margin-left: 11px;
        min-width: 160px;
        height: 22px;
        border: none;
        text-align: center;
        background-color: transparent;
        border-bottom: 1px solid #333333;
    }
    .tk_textarea{
		margin-left: 11px;
		padding: 5px 11px;
		resize: none;
		font-size: 20px;
        background-color: transparent;
        border-bottom: 1px solid #333333;
		border-radius: 3px;
    }

    .answer_tiankong {
        padding: 0 10px;
        display: inline-block;
        width: 60px;
        height: 22px;
        text-align: center;
        background-color: transparent;
        border-bottom: 1px solid #333333;
    }

    .right {
        color: #1dc11d;
    }

    .error {
        color: #ff0000;
    }

    .content_html p input:focus {
        outline: none;
        border-bottom: 1px solid #333333 !important;
    }
</style>
<style lang="less" scoped>
    .container {
        background: #87C8FA;
        position: relative;
    }
    .money_animate {
        width: 100%;
        height: 100%;
        flex-wrap: nowrap;
        position: fixed;
        top: 0;
        left: 0;
        background: url("../assets/images/money_animate.gif") no-repeat;
        background-size: 100% 100%;
        z-index: 1000;
    }
    .mask {
        width: 100%;
        height: 100%;
        flex-wrap: nowrap;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        background: rgba(0, 0, 0, 0.7);
    }
    .Subject_right_float {
        width: 340px;
        height: 100%;
        background-color: #333;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 50px;
        /*right: 6rem;*/
        /*min-height: 670px;*/
    }

    .challenge_content {
        width: 960px;
        margin: 20px 100px 50px 100px;
        /*margin: 80px 100px 150px 100px;*/
        min-height: 610px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;

        .section_name {
            height: 32px;
            line-height: 32px;
            text-align: left;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        .content_nav {
            min-height: 610px;
            width: 960px;
            display: flex;

            .topic {
                width: 768px;
                min-height: 610px;
                background-color: #fff;
                position: relative;
                border-radius: 4px;

                .title {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 40px;
                    /*background-color: #fff;*/

                    span {
                        font-size: 16px;
                        color: #333;
                        font-weight: 500;
                    }

                    .tipic_num {
                        display: inline-block;
                        width: 48px;
                        line-height: 40px;
                        height: 40px;
                        color: #fff;
                        text-align: center;
                        background-color: #333333;
                        border-radius: 4px 0 0px 0;
                    }

                    .tipic_desc {
                        display: inline-block;
                        width: 96px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        border-radius: 0 0 4px 0;
                        background-color: #0079FE;
                    }
                }

                .topic_content {
                    padding: 24px 50px 80px 24px;
                    color: #333333;
                    line-height: 22px;

                    .topic_option {
                        .option_item {
                            position: relative;
                            // 单选、判断
                            /deep/ .el-radio.is-bordered {
                                height: auto;
                            }

                            /deep/ .el-radio {
                                display: flex;
                                height: auto;
                                width: 550px;
                                max-width: 550px;
                                margin-top: 12px;
                                padding: 0px 0px 0 0;

                                &:first-child {
                                    // margin-top: 32px;
                                    margin-top: 15px;
                                }

                                .el-radio__input {
                                    display: none;
                                }

                                .el-radio__label {
                                    display: flex;
                                    line-height: 40px;
                                    padding: 0;

                                    .item_content {
                                        padding: 0 20px;
                                        max-width: 460px;
                                        overflow: hidden;
                                        white-space: pre-wrap;
                                    }

                                    .space {
                                        display: inline-block;
                                        text-align: center;
                                        width: 40px;
                                        height: auto;
                                        border-right: 1px solid #dcdfe6;
                                    }

                                    .judge_item {
                                        padding-left: 20px;
                                        width: 530px;
                                    }
                                }
                            }

                            // 多选
                            /deep/ .el-checkbox {
                                display: flex;
                                height: auto;
                                width: 550px;
                                max-width: 550px;
                                margin-top: 12px;
                                padding: 0px 0px 0 0;

                                &:first-of-type {
                                    margin-top: 32px;
                                }

                                .el-checkbox__input {
                                    display: none;
                                }

                                .el-checkbox__label {
                                    display: flex;
                                    line-height: 40px;
                                    padding: 0;

                                    .item_content {
                                        padding: 0 20px;
                                        max-width: 460px;
                                        overflow: hidden;
                                        white-space: pre-wrap;
                                    }

                                    .space {
                                        display: inline-block;
                                        text-align: center;
                                        width: 40px;
                                        height: auto;
                                        border-right: 1px solid #dcdfe6;
                                    }

                                    .judge_item {
                                        padding-left: 20px;
                                        width: 530px;
                                    }
                                }
                            }
                        }
                    }
                }

                .next {
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    background-color: #eeeeee;
                    height: 56px;
                    width: 100%;

                    .next_btn {
                        cursor: pointer;
                        padding: 0 15px;
                        font-size: 14px;
                        line-height: 28px;
                        margin-right: 48px;
                        margin: 12px 48px 12px 0;
                        height: 28px;
                        background-color: #0079fe;
                        color: #fff;
                        border-radius: 4px;
                    }

                    .isdisabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
            }

            .topic_step2 {
                width: 768px;
                min-height: 610px;
                background-color: #fff;
                position: relative;
                border-radius: 4px;

                .title {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 40px;
                    background-color: #fff;

                    span {
                        font-size: 16px;
                        color: #333;
                        font-weight: 500;
                    }

                    .tipic_num {
                        display: inline-block;
                        width: 48px;
                        line-height: 40px;
                        height: 40px;
                        color: #fff;
                        text-align: center;
                        background-color: #333333;
                        border-radius: 4px 0 0px 0;
                    }

                    .tipic_desc {
                        display: inline-block;
                        width: 96px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        border-radius: 0 0 4px 0;
                        background-color: #0079FE;
                    }
                }

                .topic_content {
                    padding: 24px 50px 24px 24px;
                    color: #333333;
                    line-height: 22px;

                    .topic_title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;

                        .content_html {
                            width: 420px;
                        }

                        .right,
                        .error {
                            display: inline-block;
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            text-align: center;
                            line-height: 28px;
                            color: #fff;
                            font-size: 28px;
                            font-weight: 600;
                        }

                        .right {
                            background-color: #1dc11d;
                        }

                        .error {
                            background-color: #ff0000;
                        }
                    }

                    .answer_div {
                        margin-top: 25px;
                        font-size: 14px;
                        font-weight: 500;

                        .answer {
                            color: #1dc11d;
                            display: inline-block;
                            border-bottom: 1px solid #1dc11d;
                            margin-right: 20px;
                        }
                    }

                    .topic_option {
                        margin-top: 15px;

                        .select_option {
                            display: flex;
                            margin-top: 5px;
                            border: 1px solid #DDDDDD;
                            align-items: center;
                            flex: 1;
                            border-radius: 6px;

                            .num {
                                width: 40px;
                                display: inline-block;
                                height: 100%;
                                text-align: center;
                                border-right: 1px solid #DDDDDD;
                            }

                            .select_content {
                                height: auto;
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                flex: 1;
                                padding: 10px;
                                justify-content: space-between;

                                .type1AndType2Img {
                                    width: 32px;
                                    height: 32px;
                                    margin: -10px -26px -10px 0;
                                    background: white
                                }

                                .type4Img {
                                    width: 32px;
                                    height: 32px;
                                    margin: -10px -32px -10px 0;
                                    background: white
                                }
                            }

                            .right_icon {
                                background: #3BA9F6;
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                justify-self: flex-end;
                                margin: -10px -25px -10px 0px;
                                color: white;
                                display: flex;
                                align-items: center;
                                font-size: 26px;
                            }

                            .error_icon {
                                background: #FF0000;
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                justify-self: flex-end;
                                margin: -10px -25px -10px 0px;
                                color: white;
                                text-align: center;
                                font-size: 26px;
                            }

                            span {
                                &:first-of-type {
                                    margin-right: 5px;
                                }
                            }
                        }

                        .select_active {
                            border: 2px solid #0079FE;
                            border-radius: 6px;
                        }

                        .select_right {
                            color: #1dc11d;
                        }

                        .select_error {
                            color: #ff0000;
                        }

                        .select_Num {
                            border: 2px solid #0079FE;
                        }
                    }
                }

                .content_bottom {
                    margin: 0px 24px 5px 24px;

                    .fieldset {
                        border: 1px solid #eeeeee;
                        text-align: center;

                        .legend {
                            font-size: 16px;
                            color: #333333;
                            padding: 0 22px;
                        }

                        .zhishidian {
                            padding: 8px 24px;
                            display: flex;
                            cursor: pointer;

                            .item {
                                padding: 0 12px;
                                margin-right: 20px;
                                height: 30px;
                                line-height: 30px;
                                color: #333333;
                                font-size: 14px;
                                border: 1px solid #DDDDDD;
                                border-radius: 20px;
                            }
                        }
                    }

                    .knowledge {
                        background-color: #0079FE;
                        height: 38px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0px 12px;

                        .knowledge_content {
                            font-size: 12px;
                            color: #fff;
                            line-height: 18px;
                            cursor: pointer;

                            .bi {
                                background-color: #fff;
                                padding: 2px;
                                font-size: 12px;
                                color: #0079FE;
                                margin-right: 5px;
                            }
                        }

                        .intelligent_tutoring {
                            font-size: 14px;
                            line-height: 22px;
                            color: #fff;
                            width: 80px;
                            cursor: pointer;

                            i {
                                color: #fff;
                            }
                        }
                    }
                }

                .next {
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    background-color: #eeeeee;
                    height: 56px;
                    width: 100%;

                    .next_btn {
                        cursor: pointer;
                        padding: 0 15px;
                        font-size: 14px;
                        line-height: 28px;
                        margin-right: 48px;
                        margin: 12px 48px 12px 0;
                        height: 28px;
                        background-color: #0079fe;
                        color: #fff;
                        border-radius: 4px;
                    }

                    .isdisabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
            }
        }

        .Subject_right {
            width: 392px;
            /*width: 192px;*/
            min-height: 610px;
            background-color: #333;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }


    }

    .challenge_content .Subject_left {
        width: 800px;
        height: 550px;
        background-color: #fff;
    }

    .progress {
        width: 760px;
        height: auto;
        margin: 30px 20px;
    }

    .progress .stem {
        display: block;
        width: 760px;
        height: auto;
        line-height: 25px;
        font-size: 15px;
        font-weight: bold;
    }

    .row {
        display: flex;
        flex-direction: row;
        width: 760px;
        height: 45px;
        margin: 10px 0;
        line-height: 20px;
        font-size: 14px;
        justify-content: space-around;
        color: #444;
    }

    .progress .title {
        display: block;
        width: 760px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        margin: 10px 0;
    }

    .row .letter {
        width: 30px;
        height: auto;
        margin: 15px 0;
    }

    .row .row_box {
        width: 50px;
        height: auto;
        display: flex;
        flex-direction: row;
    }

    .row .box2 {
        width: 20px;
        height: 20px;
        font-size: 15px;
        text-align: center;
        border-radius: 50%;
        margin: 15px 0;
        color: #f0f;
        background-color: #ccc;
    }

    .row .box3 {
        width: 700px;
        height: auto;
        margin: 15px 5px;
    }

    .box4 {
        width: 20px;
        height: 20px;
    }

    .box6 {
        position: relative;
        width: 50px;
        height: 40px;
        left: 620px;
    }

    .next_div {
        position: fixed;
        width: 800px;
        height: 40px;
        margin: 100px 0 10px 0;
    }

    .Popup {
        width: 80px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        color: #999;
        cursor: pointer;
        text-align: center;
        margin: 0 0 30px 0px;
        background-color: #333333;
        border-radius: 40px;
        border: 1px solid #fff;
    }

    .times {
        width: 374px;
        height: 65px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .times .title_name {
        width: 374px;
        height: 17px;
        line-height: 17px;
        font-size: 15px;
        color: #fff;
        text-align: center;
    }

    .times .title_time {
        height: 45px;
        display: flex;
        line-height: 45px;
        font-size: 32px;
        color: #fff;
        font-weight: 700;
    }

    .hides {
        width: 374px;
        height: 300px;
        display: flex;
        flex-direction: column;
        margin: 0 13px 2px 13px;
        .hide {
            width: 374px;
            height: 82px;

            .title {
                width: 374px;
                height: 22px;
                line-height: 22px;
                text-align: center;
                font-size: 15px;
                color: #d7d7d7;
            }

            .challenge_progress {
                height: 146px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-left: 16px;
                /*margin-top: 40px;*/

                .progress_div {
                    width: 360px;
                    height: 146px;
                    position: relative;

                    .img {
                        width: 130px;
                        height: 146px;
                    }

                    .center_img {
                        width: 86px;
                        height: 96px;
                        position: absolute;
                        left: 22px;
                        top: 24px;
                    }

                    .progress_item1 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        left: 19px;
                        top: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item2 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        right: 19px;
                        top: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item3 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 60px;
                        right: -12px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item4 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        right: 19px;
                        bottom: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item5 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        left: 19px;
                        bottom: 3px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .progress_item6 {
                        border-radius: 50%;
                        background: #ffffff;
                        width: 28px;
                        height: 28px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 60px;
                        left: -12px;

                        .num {
                            font-size: 20px;
                            color: #DDDDDD;
                        }
                    }

                    .finished_progress_item {
                        background-color: #0079FE;
                        color: #FFFFFF;
                    }

                    .unfinished_progress_item {
                        background-color: #FFFFFF;
                        color: #DDDDDD;
                    }

                    .current_progress_item {
                        background-color: #F6A31E;
                        color: #FFFFFF;
                    }

                    .right_progress_item {
                        background-color: #1DC11D;
                        color: #FFFFFF;
                    }

                    .error_progress_item {
                        background-color: #FF0000;
                        color: #FFFFFF;
                    }

                }

            }

            .line {
                text-align: center;
                color: #d7d7d7;
                border: 1px solid #d7d7d7;
                margin-top: 5px;
            }

            .questions {
                width: 174px;
                height: 60px;
                display: flex;
                flex-direction: row;
                margin-top: 20px;

                .correct {
                    width: 25px;
                    height: 60px;
                    margin-left: 34px;
                }

                .error {
                    width: 25px;
                    height: 60px;
                    margin-right: 25px;
                    margin-left: 60px;
                }

                .number {
                    height: 40px;
                    line-height: 40px;
                    font-size: 32px;
                    color: #f3f3f3;
                    font-weight: 700;
                    text-align: center;
                }

                .name {
                    width: 25px;
                    height: 14px;
                    text-align: center;
                    font-size: 12px;
                    color: #f3f3f3;
                    padding-top: 7px;
                }
            }

            .tips {
                width: 174px;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                margin: 25px 0 2px 0;
                color: #d7d7d7;
                text-align: center;
            }

            .imgs {
                width: 174px;
                height: 140px;
                margin-top: 10px;
                text-align: center;

                .img {
                    width: 140px;
                    height: 140px;
                }
            }

            .submit {
                width: 100px;
                height: 40px;
                line-height: 40px;
                margin: 25px 37px 25px 37px;
                border: 1px solid #fff;
                text-align: center;
                border-radius: 10px;
                font-size: 15px;
                color: #fff;
            }

            .again {
                margin-top: 50px;
                display: flex;
                justify-content: center;

                .btn {
                    height: 32px;
                    line-height: 32px;
                    background-color: #0079FE;
                    cursor: pointer;
                    border-radius: 3px;
                    width: 88px;
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                }
            }
        }

    }


    #dian {
        margin: 77px 37px 25px 37px;
        text-align: center;

        .finish_btn {
            padding: 12px 33px;
            font-size: 15px;
        }

    }

    .footer {
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        position: fixed;
        bottom: 0;
        align-items: center;

        .bottom {
            width: 100%;
            height: 20px;
            margin: 0 auto;

            .railway {
                height: 50px;

                .img4 {
                    width: 100%;
                    height: 50px;
                }
            }
        }

        .top {
            width: 1400px;
            height: 50px;
            display: flex;
            flex-direction: row;

            .hill {
                height: 50px;
                display: flex;
                flex-direction: row;

                .img3 {
                    width: 200px;
                    height: 50px;
                }
            }

            .train {
                height: 40px;
                display: flex;
                padding: 0 20px;
                flex-direction: row;

                .train_num {
                    height: 40px;
                    margin-top: 10px;
                    display: flex;

                    .train_item {
                        position: relative;
                        cursor: pointer;

                        .span_num1, .span_num2, .span_num3 {
                            display: inline-block;
                            width: 20px;
                            height: 28px;
                            text-align: center;
                            line-height: 30px;
                            font-size: 16px;
                            position: absolute;
                        }

                        .span_num1 {
                            bottom: 5px;
                            right: 4px;
                        }

                        .span_num2 {
                            bottom: 5px;
                            right: 5px;
                        }

                        .span_num3 {
                            bottom: 5px;
                            left: 5px;
                        }

                        .isfinish {
                            /*background-color: #0079FE;*/
                            background-color: #0000C6;
                            color: #fff;
                        }

                        .nofinish {
                            background-color: skyblue;
                        }

                        .gou {
                            background-color: #1DC11D;
                            color: #fff;
                        }

                        .cha {
                            background-color: #FF0000;
                            color: #fff;
                        }
                    }

                    .img1 {
                        width: 100px;
                        height: 40px;
                    }

                    .img2 {
                        width: 90px;
                        height: 40px;
                        z-index: -1;
                    }
                }

                // @viewWidth: 100vw;
                .train_run {
                    position: relative;
                    animation: mymove 1.5s linear;
                    -webkit-animation: mymove 1.5s linear; /*Safari and Chrome*/
                }

                @keyframes mymove {
                    1% {
                        left: 0px;
                    }
                    100% {
                        left: 1500px;
                    }
                }
                @-webkit-keyframes mymove /*Safari and Chrome*/ {
                    1% {
                        left: 0px;
                    }
                    100% {
                        left: 1500px;
                    }
                }

                .diaplayNone {
                    opacity: 0;
                }

                .train_run2 {
                    opacity: 1;
                    position: relative;
                    animation: mymove2 1.5s linear;
                    -webkit-animation: mymove2 1.5s linear; /*Safari and Chrome*/
                }

                @keyframes mymove2 {
                    1% {
                        left: -1500px;
                    }
                    100% {
                        left: 0;
                    }
                }
                @-webkit-keyframes mymove2 /*Safari and Chrome*/ {
                    1% {
                        left: -1500px;
                    }
                    100% {
                        left: 0;
                    }
                }

                .img3 {
                    margin-left: 30px;
                    width: 200px;
                    height: 50px;
                }
            }
        }
    }

    /* 弹窗 */
    .EscModal {
        width: 432px;
        height: 192px;

        .Tips {
            z-index: -1;
            text-align: center;

            .top {
                height: 100px;

                .center {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 10px;

                    .img {
                        width: 60px;
                        height: 60px;
                    }
                }

                .p1 {
                    font-size: 16px;
                    padding-left: 37px;
                    text-align: left;
                    color: #333333;

                    .warning {
                        background-color: #FFBF00;
                        color: #ffffff;
                        display: inline-block;
                        width: 22px;
                        height: 22px;
                        text-align: center;
                        border-radius: 50%;
                        line-height: 22px;
                        margin-right: 7px;
                    }
                }

                .p2 {
                    padding-left: 70px;
                    text-align: left;
                    font-size: 14px;
                    color: #666666;
                }
            }

            .btn_div {
                margin-top: 20px;
                margin-bottom: 10px;

                .btn {
                    width: 88px;
                    height: 32px;
                    text-align: center;
                    cursor: pointer;
                    padding: 0;
                }
            }
        }
    }

    .video_operation {
        padding: 18px 0;

        .default-div {
            display: inline-block;
            border-radius: 8px;
            padding: 8px 16px;
            background-color: #F2F2F2;
            cursor: pointer;
            color: #9C9C9C;
            font-size: 14px;
            margin: 0 12px 10px 0;
        }
        .selected-div {
            display: inline-block;
            border-radius: 8px;
            padding: 8px 16px;
            background-color: #1677FF;
            cursor: pointer;
            color: #FFFFFF;
            font-size: 14px;
            margin: 0 12px 10px 0;

        }
    }
    .bottom_analysis {
        margin-top: 10px;
        line-height: 22px;
    }
</style>
